import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useTranslation } from 'react-i18next'
import { ButtonBind } from './ButtonBind'

interface MyAccountPhoneProps {
  isBound: boolean
  canUnBind?: boolean
  phone?: string
  onClick?: () => void
}

export function MyAccountPhone(props: MyAccountPhoneProps) {
  const { t } = useTranslation()
  const { isBound, canUnBind, phone, onClick } = props

  return (
    <>
      <HStack justifyContent="space-between">
        <VStack>
          <Text variant="body">{t('login.phoneNumber')}</Text>
          <Text color="gray">{phone || t('login.notSet')}</Text>
        </VStack>
        <ButtonBind
          onClick={onClick}
          isBound={isBound}
          canUnBind={canUnBind}
          text={t('login.verifyPhone')}
        />
      </HStack>
    </>
  )
}
